<template>
  <div class="hairline"></div>
</template>

<script>
  export default {
    name: "Hairline"
  }
</script>

<style lang="scss" scoped>
  .hairline {
    .device-pixel-ratio-3 &::after {
      transform: scaleY(0.33);
    }

    .device-pixel-ratio-2 &::after {
      transform: scaleY(0.5);
    }

    &::after {
      content: '';
      display: block;
      height: 1px;
      width: 100%;
      transform-origin: 50% 100%;

      .md & {
        background-color: rgba(0, 0, 0, 0.12);
      }

      .ios & {
        background-color: #C8C7CC;
      }
    }
  }
</style>
